<template>
  <div class="search-item-popular">
    <span class="search-item-popular__icon">
      <svg
        width="14" height="14"
        viewBox="0 0 14 14" fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd" clip-rule="evenodd"
          d="M6.33333 1.75C3.80203 1.75 1.75 3.80203 1.75 6.33333C1.75 8.86464 3.80203 10.9167 6.33333 10.9167C8.86464 10.9167 10.9167 8.86464 10.9167 6.33333C10.9167 3.80203 8.86464 1.75 6.33333 1.75ZM0.25 6.33333C0.25 2.9736 2.9736 0.25 6.33333 0.25C9.69307 0.25 12.4167 2.9736 12.4167 6.33333C12.4167 9.69307 9.69307 12.4167 6.33333 12.4167C2.9736 12.4167 0.25 9.69307 0.25 6.33333Z" fill="#333332"
        />
        <path
          fill-rule="evenodd" clip-rule="evenodd"
          d="M9.56928 9.56965C9.86217 9.27675 10.337 9.27675 10.6299 9.56965L13.5299 12.4696C13.8228 12.7625 13.8228 13.2374 13.5299 13.5303C13.237 13.8232 12.7622 13.8232 12.4693 13.5303L9.56928 10.6303C9.27639 10.3374 9.27639 9.86254 9.56928 9.56965Z" fill="#333332"
        />
      </svg>
    </span>
    <span class="search-item-popular__name">{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: 'search-item-popular',

  props: {
    name: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.search-item-popular {
  display: flex;
  align-items: center;
  padding: 8px 0;
  cursor: pointer;

  &:hover,
  &:active,
  &:focus-visible {
    & .search-item-popular__name {
      color: #E30613;
    }
  }

  &__icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    opacity: .3;
  }

  &__name {
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #333332;
  }
}
</style>
